/* eslint-disable indent */
/* eslint-disable no-undef */
export default {
	name: "depot-attendant-management",
	props:{
		depotId: {
			default: null
		},
		depotName: {
			default: null
		}
	},
	data() {
		return {
			attendants: [],
			attendantsHeadings: [
				{
					text: "First Name",
					field: "firstName"
				},
				{
					text: "Last Name",
					field: "lastName"
				},
				{
					text: "Attendant Number",
					field: "attendantNumber"
				},
				{
					text: "Is Active",
					field: "isActiveAsString"
				}
			],
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			actionKeys:{
				edit: "edit",
				markAsActiveInactive: "markAsActiveInactive",
				transferToDepot: "transferToDepot"
			},
			attendantAddEditFormModal:{
				showModal: false,
				isSaving: false,
				modalId: "addEditAttendantModal",
				heading: "Add Attendant",
				attendant:{
					depotAttendantId: null,
					firstName: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					lastName: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					attendantNumber: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					phoneNumber: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					emailAddress: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					depotId: null,
					isActive: true
				}
			},
			attendantMarkAsActiveInactiveModal:{
				showModal: false,
				isSaving: false,
				modalId: "markAsActiveInactiveAttendantModal",
				heading: "Mark Attendant As Active/Inactive",
				isActive: true,
				depotAttendantId: null
			},
			transferAttendantModal:{
				showModal: false,
				isSaving: false,
				modalId: "transferAttendantModal",
				heading: "Transfer Attendant to Another Depot",
				depotAttendantId: null,
				attendantName: null,
				attendantNumber: null,
				newDepotId: {
					value: null,
					hasError: false,
					errorMessage: null
				}
			},
			filterStateChanged: false,
			filter:{
				searchQuery: null,
				activeOrInactiveItems: 1
			},
			activeIsActiveKey:{
				active: 1,
				inactive: 0
			},
			pageNumber: 1,
			pageSize: 100,
			loading: false,
			depots: []
		};
	},
	methods: {
		getAttendants() {
			this.loading = true;
			systemService.getDepotAttendants(
				this.depotId,
				castingUtility.toBoolean(this.filter.activeOrInactiveItems),
				this.filter.searchQuery
			).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.attendants = successResponse.data.result;
						for(let i = 0; i < this.attendants.length; i++){
                            this.attendants[i].isActiveAsString = this.attendants[i].isActive ? "Yes" : "No";
							this.attendants[i].actions = [
								{
									name: "Edit",
									key: this.actionKeys.edit
								},
								{
									name: this.attendants[i].isActive ? "Mark As Inactive" : "Mark As Active",
									key: this.actionKeys.markAsActiveInactive
								},
								{
									name: "Transfer to Depot",
									key: this.actionKeys.transferToDepot
								}
							];
						}
						this.filterStateChanged = false;
					}
					this.loading = false;
				}, errorResponse => {
					apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(errorResponse.response.data.responseStatus, errorResponse.response.data.httpStatusCode, errorResponse.response.data.message);
					this.loading = false;
				}
			);
		},
		getDepots() {
			let request = {
				isActive: true,
				searchQuery: "",
				provinceId: 0
			};
			systemService.getAllDepots(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.depots = [];
						for(let i = 0; i < successResponse.data.result.length; i++){
							this.depots.push({
								text: successResponse.data.result[i].name,
								id: successResponse.data.result[i].depotId
							});
						}
					}
				}, errorResponse => {
					apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(errorResponse.response.data.responseStatus, errorResponse.response.data.httpStatusCode, errorResponse.response.data.message);
				}
			);
		},
		onAttendantActionClicked(actionAndData){
			if(actionAndData.action === this.actionKeys.edit){
				this.onEditAttendantClick(actionAndData.data);
			}
			if(actionAndData.action === this.actionKeys.markAsActiveInactive){
				this.onMarkAsActiveInactiveClick(actionAndData.data);
			}
			if(actionAndData.action === this.actionKeys.transferToDepot){
				this.onTransferToDepotClick(actionAndData.data);
			}
		},
		onAddAttendantClick(){
			this.attendantAddEditFormModal.heading = "Add Attendant - " + this.depotName;
			this.resetAttendantForm();
			this.attendantAddEditFormModal.showModal = true;
		},
		onEditAttendantClick(attendant){
			this.attendantAddEditFormModal.heading = "Edit Attendant";
			this.resetAttendantForm();
			this.attendantAddEditFormModal.attendant.depotAttendantId = attendant.depotAttendantId;
			this.attendantAddEditFormModal.attendant.firstName.value = attendant.firstName;
			this.attendantAddEditFormModal.attendant.lastName.value = attendant.lastName;
			this.attendantAddEditFormModal.attendant.attendantNumber.value = attendant.attendantNumber;
			this.attendantAddEditFormModal.attendant.isActive = attendant.isActive;
			this.attendantAddEditFormModal.showModal = true;
		},
		onMarkAsActiveInactiveClick(attendant){
			this.attendantMarkAsActiveInactiveModal.depotAttendantId = attendant.depotAttendantId;
			this.attendantMarkAsActiveInactiveModal.isActive = !attendant.isActive;
			this.attendantMarkAsActiveInactiveModal.showModal = true;
		},
		onTransferToDepotClick(attendant){
			this.transferAttendantModal.depotAttendantId = attendant.depotAttendantId;
			this.transferAttendantModal.attendantName = attendant.firstName + " " + attendant.lastName;
			this.transferAttendantModal.attendantNumber = attendant.attendantNumber;
			this.transferAttendantModal.newDepotId.value = null;
			this.transferAttendantModal.newDepotId.hasError = false;
			this.transferAttendantModal.newDepotId.errorMessage = null;
			this.transferAttendantModal.showModal = true;
		},
		onAddOrEditAttendantSaveClick(){
			this.attendantAddEditFormModal.isSaving = true;
			let request = {
				depotAttendantId: this.attendantAddEditFormModal.attendant.depotAttendantId,
				depotId: this.depotId,
				firstName: this.attendantAddEditFormModal.attendant.firstName.value,
				lastName: this.attendantAddEditFormModal.attendant.lastName.value,
				attendantNumber: this.attendantAddEditFormModal.attendant.attendantNumber.value,
				isActive: this.attendantAddEditFormModal.attendant.isActive
			};
			
			systemService.addOrUpdateDepotAttendant(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
                        if(successResponse.data.depotAttendantValidationResponse.valuesAreValid){
                            this.attendantAddEditFormModal.showModal = false;
                            this.getAttendants();
                        }
						else{
                            // Handle validation errors
                            if(successResponse.data.depotAttendantValidationResponse){
                                let validation = successResponse.data.depotAttendantValidationResponse;
                                this.attendantAddEditFormModal.attendant.firstName.hasError = validation.firstNameValidationResponse.hasError;
                                this.attendantAddEditFormModal.attendant.firstName.errorMessage = validation.firstNameValidationResponse.message;

                                this.attendantAddEditFormModal.attendant.lastName.hasError = validation.lastNameValidationResponse.hasError;
                                this.attendantAddEditFormModal.attendant.lastName.errorMessage = validation.lastNameValidationResponse.message;

                                this.attendantAddEditFormModal.attendant.attendantNumber.hasError = validation.attendantNumberValidationResponse.hasError;
                                this.attendantAddEditFormModal.attendant.attendantNumber.errorMessage = validation.attendantNumberValidationResponse.message;
                            }
                        }
					}
					this.attendantAddEditFormModal.isSaving = false;
				}, errorResponse => {
					apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(errorResponse.response.data.responseStatus, errorResponse.response.data.httpStatusCode, errorResponse.response.data.message);
					this.attendantAddEditFormModal.isSaving = false;
				}
			);
		},
		onMarkAsActiveInactiveSaveClick(){
			this.attendantMarkAsActiveInactiveModal.isSaving = true;
			let request = {
				depotAttendantId: this.attendantMarkAsActiveInactiveModal.depotAttendantId,
				isActive: this.attendantMarkAsActiveInactiveModal.isActive
			};
			
			systemService.markDepotAttendantAsActiveOrInactive(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.attendantMarkAsActiveInactiveModal.showModal = false;
						this.getAttendants();
					}
					this.attendantMarkAsActiveInactiveModal.isSaving = false;
				}, errorResponse => {
					apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(errorResponse.response.data.responseStatus, errorResponse.response.data.httpStatusCode, errorResponse.response.data.message);
					this.attendantMarkAsActiveInactiveModal.isSaving = false;
				}
			);
		},
		onTransferAttendantSaveClick(){
			this.transferAttendantModal.isSaving = true;
			
			// Validate depot selection
			if(!this.transferAttendantModal.newDepotId.value){
				this.transferAttendantModal.newDepotId.hasError = true;
				this.transferAttendantModal.newDepotId.errorMessage = "Please select a depot";
				this.transferAttendantModal.isSaving = false;
				return;
			}
			
			let request = {
				depotAttendantId: this.transferAttendantModal.depotAttendantId,
				newDepotId: this.transferAttendantModal.newDepotId.value
			};
			
			systemService.transferDepotAttendantToDepot(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.transferAttendantModal.showModal = false;
                        this.$router.go(-1);
					}
					this.transferAttendantModal.isSaving = false;
				}, errorResponse => {
					apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(errorResponse.response.data.responseStatus, errorResponse.response.data.httpStatusCode, errorResponse.response.data.message);
					this.transferAttendantModal.isSaving = false;
				}
			);
		},
		onAddOrEditAttendantModalCloseClick(){
			this.attendantAddEditFormModal.showModal = false;
			this.resetAttendantForm();
		},
		onTransferAttendantModalCloseClick(){
			this.transferAttendantModal.showModal = false;
		},
		onDepotSelected(selectedDepot){
			this.transferAttendantModal.newDepotId.value = selectedDepot.id;
			this.transferAttendantModal.newDepotId.hasError = false;
			this.transferAttendantModal.newDepotId.errorMessage = null;
		},
		onFilterSearchClicked(){
			this.filterStateChanged = true;
			this.getAttendants();
		},
		onActiveInactiveFilterSelected(activeOrInactiveKey){
			this.filter.activeOrInactiveItems = activeOrInactiveKey;
		},
		resetAttendantForm(){
			this.attendantAddEditFormModal.attendant.depotAttendantId = null;
			this.attendantAddEditFormModal.attendant.firstName.value = null;
			this.attendantAddEditFormModal.attendant.firstName.hasError = false;
			this.attendantAddEditFormModal.attendant.firstName.errorMessage = null;
			this.attendantAddEditFormModal.attendant.lastName.value = null;
			this.attendantAddEditFormModal.attendant.lastName.hasError = false;
			this.attendantAddEditFormModal.attendant.lastName.errorMessage = null;
			this.attendantAddEditFormModal.attendant.attendantNumber.value = null;
			this.attendantAddEditFormModal.attendant.attendantNumber.hasError = false;
			this.attendantAddEditFormModal.attendant.attendantNumber.errorMessage = null;
			this.attendantAddEditFormModal.attendant.phoneNumber.value = null;
			this.attendantAddEditFormModal.attendant.phoneNumber.hasError = false;
			this.attendantAddEditFormModal.attendant.phoneNumber.errorMessage = null;
			this.attendantAddEditFormModal.attendant.emailAddress.value = null;
			this.attendantAddEditFormModal.attendant.emailAddress.hasError = false;
			this.attendantAddEditFormModal.attendant.emailAddress.errorMessage = null;
			this.attendantAddEditFormModal.attendant.depotId = this.depotId;
			this.attendantAddEditFormModal.attendant.isActive = true;
		},
        setBreadcrumbs() {
            var pageTitle = "Depot Attendants - " + this.depotName;
            storeState.setPageTitleAction(pageTitle);
            breadcrumbsStoreState.updateBreadcrumbs(this.$route, pageTitle);
        }
	},
	mounted: function () {
        this.setBreadcrumbs();
		this.getAttendants();
		this.getDepots();
	}
};